import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("bh_admin_token", data.token);
      toast.success("Welcome back, admin.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-teak acheik-bg-dark flex items-center justify-center px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md bg-teak-surface border border-teak-line rounded-2xl p-8 sm:p-10 shadow-2xl" data-testid="admin-login-form">
        <a href="/" className="flex items-center gap-3 mb-8 hover:opacity-90 transition-opacity" data-testid="admin-login-brand-link">
          <img src="/bh-icon-180.png" alt="BurmeseHub logo" className="w-10 h-10 rounded-full" />
          <div>
            <p className="font-display font-extrabold text-cream text-lg leading-none">BURMESE <span className="text-gold">HUB</span></p>
            <p className="text-[11px] font-mono uppercase tracking-[0.2em] text-cream/50 mt-1">Central Admin</p>
          </div>
        </a>
        <label className="block mb-4">
          <span className="block text-xs font-semibold uppercase tracking-wider text-cream/60 mb-2">Email</span>
          <input
            type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 rounded-xl bg-teak border border-teak-line text-cream text-sm outline-none focus:border-gold"
            placeholder="admin@burmesehub.com" data-testid="admin-email-input"
          />
        </label>
        <label className="block mb-7">
          <span className="block text-xs font-semibold uppercase tracking-wider text-cream/60 mb-2">Password</span>
          <input
            type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-3 rounded-xl bg-teak border border-teak-line text-cream text-sm outline-none focus:border-gold"
            placeholder="••••••••" data-testid="admin-password-input"
          />
        </label>
        <button
          type="submit" disabled={busy}
          className="w-full bg-gold hover:bg-gold-dark disabled:opacity-60 text-ink font-bold py-3.5 rounded-xl transition-colors"
          data-testid="admin-login-submit"
        >
          {busy ? "Signing in…" : "Sign in to dashboard"}
        </button>
      </form>
    </div>
  );
}
